module.exports = __webpack_public_path__ + "static/media/production.abbf3278.jpg";